/*       */
import React from 'react';

import EventTypeSidebar from 'app/containers/Sidebars/EventTypeSidebar';

import { buildSidebar as buildSidebarAction, closeSidebar as closeSidebarAction } from 'store/actions/sidebar/sidebarActions';

export const openEventTypeSidebar = ({ id, title, reloadList }) => async (dispatch, getState) => {
    return buildSidebarAction({
        title,
        content: <EventTypeSidebar id={id} title={title} reloadList={reloadList} />,
        isOpen: true,
    })(dispatch, getState);
};

export const closeEventTypeSidebar = closeSidebarAction;
